"use client";

import { type AnchorHTMLAttributes } from "react";

import {
  buildRedirectUrl,
  type OutboundBiParams,
} from "@/lib/affiliate/build-redirect-url";
import { fireBingOutboundConversion } from "@/lib/tracking/bing-conversion";
import { fireOutboundConversion } from "@/lib/tracking/conversion";

export type OutboundLinkProps = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  "href"
> & {
  url: string;
  storeName: string;
  bi: OutboundBiParams;
};

/**
 * Renders an outbound affiliate `<a>` with tracking guarantees.
 * Builds the redirect URL internally so BI event params are always present.
 * Fires Google Ads and Bing UET conversion events on click.
 */
export function OutboundLink({
  url,
  storeName,
  bi,
  onClick,
  children,
  ...props
}: OutboundLinkProps) {
  const href = buildRedirectUrl(url, storeName, bi);

  return (
    <a
      {...props}
      href={href}
      onClick={(e) => {
        onClick?.(e);
        if (!e.defaultPrevented) {
          fireOutboundConversion();
          fireBingOutboundConversion();
        }
      }}
    >
      {children}
    </a>
  );
}
